{
  "shcA": {
    "dashboard": {
      "title": "Panel klienta",
      "welcome": "Witaj w panelu klienta"
    },
    "myData": {
      "title": "Moje dane"
    },
    "orders": {
      "title": "Zamówienia",
      "youHave": "Masz",
      "activeOrders": "zamówień"
    },
    "wishlist": {
      "title": "Lista życzeń",
      "noProducts": "Brak produktów. Dodaj coś do listy życzeń"
    },
    "address": {
      "heading": "Zarządzaj adresami",
      "firstName": "Imię",
      "lastName": "Nazwisko",
      "phone": "Telefon",
      "add": "Dodaj nowe dane",
      "save": "Zapisz dane",
      "edit": "Edytuj dane",
      "new": "Nowy adres",
      "success": "Adres został zapisany",
      "person": "Osoba prywatna",
      "company": "Firma",
      "removeQuestion": "Usunąć adres?",
      "remove": "Usuń",
      "removeSuccess": "Adres został usunięty",
      "noAddress": "Brak adresów",
      "companyFullName": "Pełna nazwa firmy",
      "vatId": "Nip",
      "name": "Imię i nazwisko",
      "address": "Adres",
      "postCode": "Kod pocztowy",
      "city": "Miejscowość",
      "phoneNumber": "Numer telefonu",
      "defaultShipping": "domyślny adres dostawy",
      "defaultBilling": "domyślny adres rachunku",
      "country": "Kraj"
    }
  }
}
